var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.991 1C8.21136 1.00178 6.47218 1.53114 4.99333 2.52115C3.51447 3.51116 2.36232 4.91739 1.68251 6.56208C1.0027 8.20677 0.825753 10.0161 1.17404 11.7613C1.52232 13.5066 2.38019 15.1094 3.63922 16.3671C4.89825 17.6249 6.50191 18.4812 8.2475 18.8277C9.99308 19.1743 11.8022 18.9955 13.4462 18.3141C15.0902 17.6326 16.4953 16.479 17.4839 14.9992C18.4724 13.5193 19 11.7796 19 10C19 8.81735 18.7669 7.64629 18.3141 6.55377C17.8612 5.46125 17.1975 4.4687 16.3608 3.63286C15.5241 2.79701 14.5309 2.13427 13.4379 1.6825C12.3449 1.23074 11.1737 0.998822 9.991 1ZM10 17.2C8.57598 17.2 7.18393 16.7777 5.9999 15.9866C4.81586 15.1954 3.89302 14.0709 3.34807 12.7553C2.80312 11.4397 2.66054 9.99201 2.93835 8.59535C3.21616 7.19869 3.9019 5.91577 4.90883 4.90883C5.91577 3.9019 7.19869 3.21616 8.59535 2.93835C9.99202 2.66054 11.4397 2.80312 12.7553 3.34807C14.071 3.89302 15.1954 4.81586 15.9866 5.9999C16.7777 7.18393 17.2 8.57598 17.2 10C17.2 11.9096 16.4414 13.7409 15.0912 15.0912C13.7409 16.4414 11.9096 17.2 10 17.2ZM10.45 5.5H9.1V10.9L13.825 13.735L14.5 12.628L10.45 10.225V5.5Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClock);
export default __webpack_public_path__ + "static/media/time_clock.80595aad.svg";
export { ForwardRef as ReactComponent };